import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';

// Layout Components
import NavBar from './components/NavBar.js';
import Sidebar from './components/Sidebar.js';
import Footer from './components/Footer.js';
import ErrorBoundary from './components/ErrorBoundary.js';

// Authentication
import { AuthProvider } from './context/AuthContext.js';
import { FirebaseProvider } from './context/FirebaseContext.js';
import ProtectedRoute from './components/ProtectedRoute.js';

// Pages
import Home from './pages/Home.js';
import Login from './pages/Login.js';
import Register from './pages/Register.js';
import Profile from './pages/Profile.js';
import UserProfile from './pages/UserProfile.js';
import UserRedirect from './pages/UserRedirect.js';
import ForgotPassword from './pages/ForgotPassword.js';
import VerifyEmail from './pages/VerifyEmail.js';
import NotFound from './pages/NotFound.js';
import Categories from './pages/Categories.js';
import Category from './pages/Category.js';
import Community from './pages/Community.js';
import Channels from './pages/Channels.js';
import Tournaments from './pages/Tournaments.js';
import Tournament from './pages/Tournament.js';
import UserTest from './components/UserTest.js';
import Stream from './pages/Stream.js';
import Browse from './pages/Browse.js';
import Teams from './pages/Teams.js';
import Settings from './pages/Settings.js';
import StreamSettings from './pages/StreamSettings.js';
import StreamManager from './pages/StreamManager.js';
import GeneralSettings from './pages/GeneralSettings.js';
import ProfileSettings from './pages/ProfileSettings.js';
import Following from './pages/Following.js';

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <FirebaseProvider>
          <AuthProvider>
            <div className="app">
              <NavBar />
              <div className="app-container">
                <Sidebar />
                <main className="main-content">
                  <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/category/:id" element={<Category />} />
                    <Route path="/community" element={<Community />} />
                    <Route path="/channels" element={<Channels />} />
                    <Route path="/stream/:username" element={<Stream />} />
                    <Route path="/tournaments" element={<Tournaments />} />
                    <Route path="/tournament/:id" element={<Tournament />} />
                    <Route path="/browse" element={<Browse />} />
                    <Route path="/teams" element={<Teams />} />
                    <Route path="/u/:username" element={<UserRedirect />} />
                    <Route path="/user/:username" element={<UserProfile />} />
                    <Route path="/user-test" element={<UserTest />} />

                    {/* Protected Routes */}
                    <Route path="/following" element={
                      <ProtectedRoute>
                        <Following />
                      </ProtectedRoute>
                    } />
                    <Route path="/settings" element={
                      <ProtectedRoute>
                        <Settings />
                      </ProtectedRoute>
                    } />
                    <Route path="/settings/general" element={
                      <ProtectedRoute>
                        <GeneralSettings />
                      </ProtectedRoute>
                    } />
                    <Route path="/settings/profile" element={
                      <ProtectedRoute>
                        <ProfileSettings />
                      </ProtectedRoute>
                    } />
                    <Route path="/stream-settings" element={
                      <ProtectedRoute>
                        <StreamSettings />
                      </ProtectedRoute>
                    } />
                    <Route path="/stream-manager" element={
                      <ProtectedRoute>
                        <StreamManager />
                      </ProtectedRoute>
                    } />
                    <Route path="/profile" element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    } />

                    {/* Error Routes */}
                    <Route path="/404" element={<NotFound />} />
                    <Route path="*" element={<Navigate to="/404" replace />} />
                  </Routes>
                </main>
              </div>
              <Footer />
            </div>
          </AuthProvider>
        </FirebaseProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default App; 